// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36yP2","left":"styles_left__3CEXt"};